import React from 'react';
import styled from 'styled-components';
import {Avatar, HomeIcon, LeadsIcon, MegaphoneIcon, ProductsIcon, RadarIcon, SettingsIcon} from 'prospect-path-base';
import {
  Logo,
  Nav,
  NavFooterMenu,
  NavFooterMenuItem,
  NavFooterMenuSection,
  NavItem,
  NavOption,
} from 'prospect-path-components';

import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import switchTeams from '../actions/SwitchTeams';
import signOut from '../actions/SignOut';
import {userInitials} from '../tools/user-initials';

// const getInitials = (name) => {
//     const singleInitials = name.charAt(0).toUpperCase();
//
//     if (name.split(" ").length > 1) {
//         const doubleName = name.split(' ');
//         const doubleInitials = doubleName.shift().charAt(0) + doubleName.pop().charAt(0);
//         return doubleInitials.toUpperCase();
//     }
//
//     return singleInitials;
// }

const FooterLink = styled.a`
    text-decoration: none;
    color: #fff;
`

const InfoIcon = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #646464;
    color: #1e1e1e;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
    font-family: serif;
    transition: background-color 0.1s, color 0.1s;
`;

const CustomNavItem = styled(NavItem)`
    &:hover ${InfoIcon} {
        background-color: #fff; /* Change circle background color on hover */
        color: #017988; /* Change icon color on hover */
    }
`;

class CmsNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.getTeams = this.getTeams.bind(this);
    this.getCurrentTeam = this.getCurrentTeam.bind(this);
    this.getUserInitials = this.getUserInitials.bind(this);
    this.openProductModal = this.openProductModal.bind(this);
    this.closeProductModal = this.closeProductModal.bind(this);
    this.handleMqlPlusClick = this.handleMqlPlusClick.bind(this);
  }

  getTeams() {
    return this.props.teams.all.filter((team) => {
      return this.props.teams.userTeams.includes(team.id);
    }).map((team) => ({
      ...team,
      selected: team.id === this.props.teams.currentTeam,
    }));
  }

  getCurrentTeam() {
    return this.props.teams.all.find((team) => {
      return this.props.teams.currentTeam === team.id;
    });
  }

  getUserInitials() {
    let displayName = this.props.user.name;

    if (displayName === null || typeof displayName === 'undefined' || displayName === '') {
      if (!this.props.vendor.loading) {
        displayName = this.props.vendor.data.name;
      } else {
        displayName = '';
      }
    }

    return userInitials(displayName);
  }

  openProductModal() {
    this.setState({isProductModalOpen: true});
  }

  closeProductModal() {
    this.setState({isProductModalOpen: false});
  }

  handleMqlPlusClick() {
    this.props.setMqlPlusFilter(true);
  };

  render() {

    const isHome = window.location.href.indexOf('home') > -1;
    const isCampaigns = window.location.href.indexOf('campaigns') > -1;
    const isLeads = window.location.href.indexOf('leads') > -1;
    const isIntentData = window.location.href.indexOf('intent-data') > -1;
    const isProducts = window.location.href.indexOf('products') > -1 || window.location.href.indexOf('signup/product') > -1;
    const isSettings = window.location.href.indexOf('settings') > -1;
    const isBilling = window.location.href.indexOf('billing') > -1;
    const isLeadReturn = window.location.href.indexOf('lead-return') > -1;
    const isTQLeads = window.location.href.indexOf('leads/tq') > -1;
    const isPurchased = window.location.href.indexOf('leads/purchased') > -1;
    const isAvailable = window.location.href.indexOf('leads/available') > -1;
    const isArchived = window.location.href.indexOf('leads/archived') > -1;
    const isMqlPlusLeads = window.location.href.indexOf('leads/mql') > -1;
    const isCrmIntegration = window.location.href.indexOf('crm-integration') > -1;
    const isLeadSubmission = window.location.href.indexOf('lead-submission') > -1;

    const isSettingsCollapsed = !isSettings && !isBilling && !isLeadReturn;

    return (
      <Nav
        key={this.props.user.id}
        header={<Logo/>}
        items={[
          <a href="/home" style={{'textDecoration': 'none'}}>
            <NavItem
              key="home"
              title="Home"
              icon={<HomeIcon/>}
              active={isHome}
            />
          </a>,
          <a href="/campaigns" style={{'text-decoration': 'none'}}>
            <NavItem
              key="campaigns"
              title="Campaigns"
              icon={<MegaphoneIcon/>}
              active={isCampaigns}
            />
          </a>,
          // <a href="/leads" style={{'textDecoration': 'none'}}>
          <a href="/leads/available" style={{'textDecoration': 'none'}}>
            <NavItem
              key="leads"
              title="Leads"
              icon={<LeadsIcon/>}
              active={isLeads}
            />
          </a>,
          <NavOption
            active={isPurchased || isArchived}
            title="Purchased Leads"
            onClick={() => window.location.href = '/leads/purchased'}
            style={{'margin-bottom': '10px', 'paddingLeft': '45px'}}
          />,
          <NavOption
            active={isAvailable}
            title="Available Leads"
            onClick={() => window.location.href = '/leads/available'}
            style={{'margin-bottom': '10px', 'paddingLeft': '45px'}}
          />,
          // <a href="/intent-data" style={{'textDecoration': 'none'}}>
          //   <NavItem
          //     key="intent"
          //     title="Intent Data"
          //     icon={<RadarIcon/>}
          //     active={isIntentData}
          //   />
          // </a>,
          this.props.featureFlags.ProductManagement &&
          <a href="/products" style={{'textDecoration': 'none'}}>
            <NavItem
              key="products"
              title="Products"
              icon={<ProductsIcon/>}
              active={isProducts}
            />
          </a>,
          <a href="user-settings" style={{'textDecoration': 'none'}}>
            <NavItem
              key="settings"
              title="Settings"
              icon={<SettingsIcon/>}
              active={isSettings || isBilling || isLeadReturn}
            />
          </a>,
          <NavOption
              active={isBilling}
              key="billing"
              title="Billing"
              onClick={() => window.location.href = '/billing'}
              style={{ paddingLeft: '45px' }}
          />,
          <NavOption
              active={isLeadReturn}
              key="lead-return"
              title="Lead Returns"
              onClick={() => window.location.href = '/lead-return'}
              style={{ paddingLeft: '45px' }}
          />,
          window.team_lead_submissions_enabled ? (
              <NavOption
                  active={isLeadSubmission}
                  key="lead-submission"
                  title="Lead Submission"
                  onClick={() => window.location.href = '/lead-submission'}
                  style={{ paddingLeft: '45px' }}
              />
          ) : null,
            window.team_crm_enabled ? <NavOption
                active={isCrmIntegration}
                key="crm-integration"
                title="CRM Integration"
                onClick={() => window.location.href = '/crm-integration'}
                style={{ paddingLeft: '45px' }}
            /> : null,
          <a href="https://support.prospectpath.com/" target="_blank"
             style={{'textDecoration': 'none', marginTop: isSettingsCollapsed ? '3px' : '15px'}}>
            <CustomNavItem
              key="support"
              title="Support"
              icon={<InfoIcon>i</InfoIcon>}
              active={false}
            />
          </a>
        ]}
        footer={(
          <NavFooterMenu
            image={<Avatar initials={this.getUserInitials()}/>}
            name={this.props.user.display_name}
            team={this.getCurrentTeam() ? this.getCurrentTeam().name : ''}
            showToggleIcon
            sections={[
              <NavFooterMenuSection
                key="teams"
                title="Team"
                items={this.getTeams().map(({id, name, selected}) => (
                  <NavFooterMenuItem
                    key={id}
                    selected={selected}
                    onClick={() => {
                      this.props.switchTeams(id);
                    }}
                  >
                    {name}
                  </NavFooterMenuItem>
                ))}
              />,
              // This should stay hidden until further work is done.
              // <NavFooterMenuSection
              //   key="add-team"
              //   items={[
              //     <NavFooterMenuItem key="add-new-team" team="Prospect Path" onClick={this.openProductModal}>
              //       Add new team
              //     </NavFooterMenuItem>,
              //     <ProductModal
              //        isOpen={this.state.isProductModalOpen}
              //        closeProductModal={this.closeProductModal}
              //     />
              //   ]}
              // />,
              <NavFooterMenuSection
                key="options"
                items={[
                  <NavFooterMenuItem key="support">
                    <FooterLink href="https://support.prospectpath.com/" target="_blank">
                      Support
                    </FooterLink>
                  </NavFooterMenuItem>,
                  <NavFooterMenuItem onClick={this.props.signOut} key="sign-out">
                    Sign out
                  </NavFooterMenuItem>
                ]}
              />
            ]}
          />
        )}
      />
    )
  }
}

CmsNav.propTypes = {
  featureFlags: PropTypes.object,
  has_accounts_data: PropTypes.bool,
};

CmsNav.defaultProps = {
  featureFlags: {},
  has_accounts_data: false,
};

const mapStateToProps = state => ({
  featureFlags: state.featureFlags,
  has_accounts_data: state.user.has_accounts_data,
  teams: state.teams,
  user: state.user,
  vendor: state.vendor,
});

const mapDispatchToProps = dispatch => ({
  switchTeams: teamId => dispatch(switchTeams(teamId)),
  signOut: () => dispatch(signOut()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CmsNav));
